var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    width: 20,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 21,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAMAAABxCz6aAAAAAXNSR0IB2cksfwAAAapQTFRF/////P378Pbv3OvZxt7Bu9i2uNezv9q6zeLJ5O/i9/r2/f39/f799fn04O3er9KpiLt+ebJuca5lb61kdK9ofrV0ksGJ6vPo+Pv49/r3yuHGhrp8b61jbaxhcK1knceV3+3c+/37yODDerNvlsOO3+3d+/z63uzag7h5dbBqnMaU8vfx7fXsqM6hbqxicK5kdrFrf7Z0y+HH+vz61OfRg7l5k8GKp8ygeLFsdLBom8aT9vr2/v7+vdq4c69omcSR4ezfy9/Hf7Z1e7Rw7/bustOsgLd2iLp+ca1ln8eY4Ove0+XPgrd3dbFq4e7e+vz5rtGnq86l1OTRnMWU2efWz+LLh7t9dbBp2urXs9Stjr6Fy+DH3OnZtdOv2+jYyN7EjL2CdrFq4+7h/v/+wNu7ca5mibuA1OXR5+/m0OPMfrZ02OjUhbl7cK5lrc+mdLBpn8mYrtGobq1icq5mbq1j0uXO4O3dir2Bd7JspMuczeLIhrp9cq9md7FroMmY4+/h+fv4j7+GebNucq9nocmZ4u7g/P385fDittWwh7t+lMKM8vfyz+PK5/LlsyOpPQAAAR9JREFUeJxjYCANMDIxs7CysXNwcnHDhHh4+fgFBIWERUTFWMQloGKSUtIyshAgJ6+gCBbkVVKGicnKCqmogsTU1DUQYrKymlraPAwMOrp6cBF9AzlZQyNjBgYTU5iQnoGZuYWspZU1g42tHYgPMkHE3sHRSVbP2YVB0RWkyM1dVtbD08vbR05W1tePwT8AKCYTGBSs6RkSGqYP5IRHMDBGAu3Ri4qOiY2LTwA7IzGJITlFE8hITUvPyISIyWQxMTBk54CYuRp5PhDn5hdwMTAwFYLZRcUlEIe5laoBfVRWjuyjikpeHpDfq6pr4GK1dfXgALFp4GhsygV7qVm0pbUNFqLtHZ2a+Zb5yl1G3TbwkG9r0FbtkTLptTbmAQkCAEInP03eXPsgAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/greenArrow.f75f52e7421674c07cdf3b9f7ab5fca7.svg";
export { ForwardRef as ReactComponent };